import { isNull, isUndefined } from 'lodash';

import api from '@/api';
import { actions as layoutActions } from '@/core/Layout/Layout.redux';
import { message } from 'antd';

const defaultLine = {
	row_index: 0,
	sap_line_id: null,
	is_child: false,

	CardCode: '',
	Dscription: '',
	UomCode: '',
	WhsCode: '',
	LineStatus: '',
	ItemCode: '',
	LineTotal: 0,
	Quantity: 1,
	Price: 0,
	gl_account_display: '', // OACT."FormatCode" + OACT."AcctName"
	DiscPrcnt: 0,
	SubCatNum: '',
	TaxCode: '',
	BPCatalogNumber: '',
	FreeTxt: '',
	Text: '',
	U_TS_Line_Remarks: '',
	U_TS_LineNotes: '',
	U_TS_LineText: '',
	U_TS_Printed_Line_Text: '',

	U_TS_Req_Date: null,
	U_TS_Com_Date: null,
	DocDueDate: null,

	U_TS_Insp_Reqd: '',
	U_TS_Prj_Name: '',
	Project: '',
	U_TS_Recipient: '',
};


const initialState = {
	loading: false,
	saving: false,
	saveButtonDisabled: true,
	saveSuccess: false,

	bp_list: [],
    shippingMethods: [],
    employees: [],
	sales_persons: [],
    states: {},
	countries: [],
	defaultCountry: 'US',
	selected_docNum: null,

	orderHeader: {
		DocEntry: null,
		DocNum: null,
		DocType: null,
		attachment_id: null,
		CardName: '',
		CntctCode: '',
		Cntct_Name: '',
		Cntct_E_MailL: '',
		Cntct_Tel1: '',
		DocStatus: '',
		Comments: '',
		JrnlMemo: '',
		Confirmed: '',
		SlpCode: -1,
		SlpName: null,
		PayToCode: '',
		TrnspCode: '',
		NumAtCard: '',
		CANCELED: '',
        Address: '',
        Address2: '',
		CancelDate: null,
        DocDate: null,
		DocDueDate: null,
		TaxDate: null,
		U_TS_Approver: '',
		U_TS_Internal_Comments: '',
		U_TS_IntNotes: '',
		U_TS_Legacy_DocNum: '',
		U_TS_Order_Purpose: '',
	},

	orderLines: [ {
		...defaultLine,
	} ],
	attachments: [],
	deleted_lines: [],

	save_response: {
		item_sync_messages: [],
		errors: [],
	},
};


export const types = {
    SET_STATE: 'PURCHASE_ORDER_ENTRY/SET_STATE',
	RESET_STATE: 'PURCHASE_ORDER_ENTRY/RESET_STATE',
};


export const reducers = (state = initialState, action) => {

    switch(action.type) {
        case types.SET_STATE:
            return { ...state, ...action.data };

		case types.RESET_STATE:
			{
				return { ...initialState };
			}

        default:
            return state;
    }
};

export const actions = {
	setState: (data) => ({ type: types.SET_STATE, data }),

    resetState: () => ({ type: types.RESET_STATE }),

    load_required_data: () => async(dispatch) => {
		dispatch(actions.setState({ loading: true }));

		try {
			let [locations, shippingMethods, employees, salesPersons, bps]  = await Promise.all([
				api.get('/bp/locations'),
				api.get('/warehouse/shipping-methods'),
				api.get('/employees/employees'),
				api.get('/employees/sales-persons'),
			]);

			let { states, countries } = locations;
			dispatch(actions.setState({
				states,
				countries,
				shippingMethods: shippingMethods.shippingMethods,
				employees: employees.employees,
				sales_persons: salesPersons.sales_persons,
			}));
		} catch (err) {
			console.error(err);
		}
	},

	load_order: (docNumber) => async(dispatch) => {
		console.log('[purchaseOrderView.redux] load_order');
		console.log('action docNum', docNumber);

		dispatch(actions.setState({ loading: true }));

		try {
			const result = await api.get('/purchase_orders/view', {
				params: {
					docNum: docNumber,
				},
			});

			const purchaseOrder = result.purchaseOrder || {};
			let attachmentsResult;

			console.log('result', result);

			if (purchaseOrder.attachment_id) {
				attachmentsResult = await api.get(`/attachmentsSAP/purchase_order/${purchaseOrder.DocEntry}`);
				console.log('attachmentsResult', attachmentsResult);
			}

			if (purchaseOrder.DocNum) {
				dispatch(layoutActions.setTitle(`Purchase Order: SAP #${purchaseOrder.DocNum}`));
			}

			const updatedOrderLines = (result.lines || []).map((line) => ({
				...line,
			}));

			dispatch(actions.setState({
				orderLines: updatedOrderLines,

				orderHeader: {
					DocEntry: purchaseOrder.DocEntry,
					DocNum: purchaseOrder.DocNum,
					DocType: purchaseOrder.DocType,
					CardCode: purchaseOrder.CardCode,
					attachment_id: purchaseOrder.attachment_id,
					CardName: purchaseOrder.CardName,
					CntctCode: purchaseOrder.CntctCode,
					Cntct_Name: purchaseOrder.Cntct_Name,
					Cntct_E_MailL: purchaseOrder.Cntct_E_MailL,
					Cntct_Tel1: purchaseOrder.Cntct_Tel1,
					DocTotal: purchaseOrder.DocTotal,
					document_type: purchaseOrder.document_type,
					DocStatus: purchaseOrder.DocStatus,

					TrnspCode: purchaseOrder.TrnspCode,
					Comments: purchaseOrder.Comments,
					JrnlMemo: purchaseOrder.JrnlMemo,
					Confirmed: purchaseOrder.Confirmed,
					SlpCode: purchaseOrder.SlpCode,
					SlpName: purchaseOrder.SlpName,
					PayToCode: purchaseOrder.PayToCode,
					NumAtCard: purchaseOrder.NumAtCard,
					OwnerCode: purchaseOrder.OwnerCode,
					CANCELED: purchaseOrder.CANCELED,

					Address: purchaseOrder.Address,
					Address2: purchaseOrder.Address2,

					CancelDate: purchaseOrder.CancelDate,
					DocDate: purchaseOrder.DocDate,
					DocDueDate: purchaseOrder.DocDueDate,
					TaxDate: purchaseOrder.TaxDate,

					U_TS_Approver: purchaseOrder.U_TS_Approver,
					U_TS_Internal_Comments: purchaseOrder.U_TS_Internal_Comments,
					U_TS_IntNotes: purchaseOrder.U_TS_IntNotes,
					U_TS_Legacy_DocNum: purchaseOrder.U_TS_Legacy_DocNum,
					U_TS_Order_Purpose: purchaseOrder.U_TS_Order_Purpose,
				},

				attachments: attachmentsResult?.attachments || [],
			}));
		} catch (err) {
			console.error(err);
		}

		dispatch(actions.setState({ loading: false }));
	},

	get_order_totals: () => (dispatch, getState) => {
		const state = getState(),
			lines = state.purchaseOrderView.orderLines;


		const totals = {
			totalQuantity: 0,
			totalPrice: 0,
			row_index: null, // done below
		};


		for (let i = 0; i < lines.length; i++) {
			const line = lines[i];

			totals.totalQuantity += line.quantity;
			totals.totalPrice += parseFloat(line.unit_price) * line.quantity;
			totals.row_index = i;
		}

		totals.totalPrice = (totals.totalPrice).toFixed(6);
		return totals;
	},

};
